import { Css, GridDataRow, GridTable, simpleHeader } from "@homebound/beam";
import { CommitmentOrChangeOrderPdf_LineItemFragment } from "src/routes/pdfs/CommitmentOrChangeOrderPdf/CommitmentOrChangeOrderPdf.generated";
import { createScopeLinesColumns, ScopeLineRow } from "src/routes/projects/commitments/components/ScopeLinesSection";
import { Section } from "../../components/Section";

type ScopeLinesSectionProps = { lineItems: CommitmentOrChangeOrderPdf_LineItemFragment[] };

export function ScopeLinesSection(props: ScopeLinesSectionProps) {
  const { lineItems } = props;
  const rows: GridDataRow<ScopeLineRow>[] = [
    simpleHeader,
    ...lineItems
      .filter((cli) => cli.primaryBidContractLineItem?.forCoveringTakeoffs)
      .map((cli) => ({ kind: "data" as const, id: cli.id, data: cli })),
  ];
  return (
    <Section title="Scope">
      <div css={Css.mb2.$}>
        <GridTable as="table" id="scopeLinesTable" columns={createScopeLinesColumns(true)} rows={rows} />
      </div>
    </Section>
  );
}
